export enum DisplayCategory {
    'DSTAT' = 'data.Code.Display_Group_Category_Cd.Code_Desc.DSTAT',
    'BSTAT' = 'data.Code.Display_Group_Category_Cd.Code_Desc.BSTAT',
    'LSTAT' = 'data.Code.Display_Group_Category_Cd.Code_Desc.LSTAT',
    'CLO' = 'data.Code.Display_Group_Category_Cd.Code_Desc.CLO',
    'CAPSN' = 'data.Code.Display_Group_Category_Cd.Code_Desc.CAPSN',
    'DEVICE' = 'label.gb.device_alerts',
    'CLINICAL' = 'data.Code.Alert_Main_Category_Cd.Code_Desc.CNLA',
    'Informational Alerts' = 'Informational Alerts',
    'INFORMATION' = 'Information',
    'TEOD' = 'data.Code.Display_Group_Category_Cd.Code_Desc.TEOD',
}
